import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SetScheduleRequest } from 'app/generated/backend/shipment/api/set-schedule-request';
import { SetScheduleResponse } from 'app/generated/backend/shipment/api/set-schedule-response';

@Injectable()
export class SetScheduleHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: SetScheduleRequest
	): Observable<JsonResourceResponse<SetScheduleResponse>> {
		return this.http.post<JsonResourceResponse<SetScheduleResponse>>('api/v1/shipment/setSchedule', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		SetScheduleHandlerService
	]
})
export class SetScheduleHandlerModule { }
